import { Reveal, Kicker } from "./Reveal";
import { Check } from "lucide-react";

const SIX_MONTH = [
  "Three paying design partners",
  "One statistically defensible lift result",
  "30%+ auto-within-bounds decisions",
  "Zero out-of-policy executions",
];

const YEAR = [
  "8–12 customers",
  "Two customers voluntarily increasing autonomy",
  "First API use outside PriceStrike",
  "First Decision Ledger audit",
  "NRR / transaction expansion evidence",
];

export default function ProofThreshold() {
  return (
    <section id="threshold" className="border-b border-white/10 bg-[#0A0A0B]" data-testid="threshold-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <Kicker index="11" label="What must be true" />
          <h2 className="max-w-5xl font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl" data-testid="threshold-heading">
            The next valuation inflection is <span className="text-[#00FF41]">evidence,</span>{" "}
            <span className="text-zinc-600">not more features.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid gap-6 lg:grid-cols-2">
          {[
            ["6-month target", SIX_MONTH, "six"],
            ["12–18 month target", YEAR, "year"],
          ].map(([title, items, key], c) => (
            <Reveal key={key} delay={c * 0.12} className="border border-white/10 bg-[#050505]">
              <div className="border-b border-white/10 px-10 py-5 font-mono text-[11px] uppercase tracking-[0.25em] text-[#00FF41]">
                {title}
              </div>
              <div className="p-10" data-testid={`threshold-${key}`}>
                {items.map((item) => (
                  <div key={item} className="flex items-center gap-4 border-b border-white/5 py-4 last:border-b-0">
                    <Check className="h-4 w-4 shrink-0 text-[#00FF41]" strokeWidth={2.5} />
                    <span className="font-mono text-sm text-zinc-300">{item}</span>
                  </div>
                ))}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-12 max-w-3xl font-mono text-sm leading-relaxed text-zinc-400" data-testid="threshold-closing">
            If customers progress from recommendation to governed autonomous execution and achieve
            measurable commercial value,{" "}
            <span className="text-white">the infrastructure thesis has behavioural evidence.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
